
//
// Injector
//

Injector = function() {
	
	var _rules = [];
	var _rulesPerSymbol = { };
	var _symbolWeights = [];
	var _symbolWeightsSum = [];
	var _selectableSymbolCount = [];
    var _symbolCreationCallbacks = {};
	
	this.symbolsLastDrawn = { };
	this.requiredSymbols = [];
	this.reelId = -1;
	this.spinReversed = false;
	
	var weightReductionFunction = function(total, currentValue, currentIndex, arr) {
		return (total + currentValue);
	}
	var symbolCountReductionFunction = function(total, currentValue, currentIndex, arr) {
		return ((currentValue > 0) ? ++total : total);
	}
	
	this.initialise = function(rules, symbolWeights, symbolCreationCallbacks) {
		//Parse rules
		for (var i = 0; i < rules.length; ++i) {
			var ruleData = rules[i];
			var ruleDataParser = Injector.ruleParsers[ruleData.type];
			
			if (ruleDataParser !== undefined) {
				var newRule = ruleDataParser(ruleData);
				_rules.push(newRule);
				if (_rulesPerSymbol[newRule.symbolId] === undefined) {
					_rulesPerSymbol[newRule.symbolId] = [];
				}
				_rulesPerSymbol[newRule.symbolId].push(newRule);
				
				if (newRule.preceeding !== undefined) {
					for (var j = 0; j < newRule.preceeding.length; ++j) {
						var symId = newRule.preceeding[j];
						if (symId === newRule.symbolId) {
							continue;
						}
						if (_rulesPerSymbol[symId] === undefined) {
							_rulesPerSymbol[symId] = [];
						}
						_rulesPerSymbol[symId].push(newRule);
					}
				}
			}
		}
		
		//Parse symbol weightings
		this.setSymbolWeights(symbolWeights);

        _symbolCreationCallbacks = ((symbolCreationCallbacks !== undefined) ? symbolCreationCallbacks : _symbolCreationCallbacks);
	};
	
	this.setSymbolWeights = function(symbolWeights) {
		_symbolWeights = [];
		_symbolWeightsSum = [];
		
		for (var i = 0; i < symbolWeights.length; ++i) {
			_symbolWeights.push(symbolWeights[i].slice());
			_symbolWeightsSum.push(symbolWeights[i].reduce(weightReductionFunction, 0));
			_selectableSymbolCount.push(symbolWeights[i].reduce(symbolCountReductionFunction, 0));
		}
	}

	this.getValidSymbol = function(preSymbolData, postSymbolData, maxGroupLength) {
        var newSymbol = {
            symbolId: -1,
            oversized: false, //oversized symbols are drawn last (optional)
            childData: [] //children are drawn over the reel symbol (optional)
        };

		if (this.requiredSymbols.length !== 0) { // Finish active groups first
            newSymbol = this.requiredSymbols.shift();
		}
		else {
			var symbolsToBeChecked = _selectableSymbolCount[this.reelId];
			var symbolsChecked = [];
			var ruleData = {
				lastDrawn: this.symbolsLastDrawn,
				maxGroupLength: maxGroupLength
			};
			
			while (newSymbol.symbolId === -1) {
				if (symbolsToBeChecked <= 0) {
					console.error("Injector is unable to find a valid symbol.");
					if (Reflex.developerModeData.canBreakInjectorRules) {
						console.error("INJECTOR RULES BROKEN: picking a random symbol");
                        newSymbol.symbolId = getRandomWeighted(_symbolWeights[this.reelId], _symbolWeightsSum[this.reelId]);
						break;
					}
				}
				
				do {
					// Get the next symbol and validate it against all the active rules
                    newSymbol.symbolId = getRandomWeighted(_symbolWeights[this.reelId], _symbolWeightsSum[this.reelId]);
					//Only continue if we haven't tried this symbol yet
				} while(symbolsChecked.find(function(element) { return (element === newSymbol.symbolId); }) !== undefined);
				
				symbolsChecked.push(newSymbol.symbolId);
				--symbolsToBeChecked;
				
				var rules = _rulesPerSymbol[newSymbol.symbolId];
				if ((rules !== undefined) && (rules.length > 0)) {
					for (var i = 0; i < rules.length; ++i) {
						var symbols = rules[i].validateSymbol(newSymbol.symbolId, preSymbolData, postSymbolData, ruleData, this.spinReversed);
						
						if (symbols === undefined) { // Rule has been broken
                            newSymbol.symbolId = -1;
							this.requiredSymbols = [];
							break;
						}
						else if ((typeof(symbols) !== 'number')) { // Rule has started a group
							this.requiredSymbols = symbols;
							
							if (rules[i].ruleType === "supersized") {
								newSymbol = this.requiredSymbols.pop();
							}
							else if (this.spinReversed) {
								newSymbol = this.requiredSymbols.unshift();
							}
						}
						else if (symbols !== newSymbol.symbolId){ //Rule has replaced the symbol
							newSymbol.symbolId = symbols;
							i = 0; //New symbol, so we need to re-run all the rules
                        }
					}
				}
			}
		}
		
		var keys = Object.keys(this.symbolsLastDrawn);
		for (var i = 0; i < keys.length; ++i) {
			++this.symbolsLastDrawn[keys[i]];
		}
		
		this.symbolsLastDrawn[newSymbol.symbolId] = 0;

		if (_symbolCreationCallbacks[newSymbol.symbolId] !== undefined) {
            newSymbol.childData = _symbolCreationCallbacks[newSymbol.symbolId](newSymbol.symbolId);
/*
            [
				{
					type: "text",
					name: ("textPanel"),
					json: {
						text: "X " + multiplier,
						fontDefinition: "reelText",
						x: 95,
						y: 101
					}
				},
				{
					...
				}
            ]
  */
		}

		return newSymbol;
	};

	this.getSymbolChildData = function(symbolId) {
        if (_symbolCreationCallbacks[symbolId] !== undefined)
        	return _symbolCreationCallbacks[symbolId](symbolId);

        return [];
	};
	
	this.getDistanceToNext = function(symbol, nextSymbol) {
		var distance = 0;
		
		var symbolRules = _rulesPerSymbol[symbol];
		if ((symbolRules !== undefined) && (symbolRules.length > 0)) {
			for (var i = 0; i < symbolRules.length; ++i) {
				if (symbolRules[i].ruleType === "distance") {
					distance = Math.max(distance, symbolRules[i].minDistance);
				}
			}
		}
		
		var nextSymbolRules = _rulesPerSymbol[nextSymbol];
		if ((nextSymbolRules !== undefined) && (nextSymbolRules.length > 0)) {
			for (var i = 0; i < nextSymbolRules.length; ++i) {
				if (nextSymbolRules[i].ruleType === "distance") {
					distance = Math.max(distance, nextSymbolRules[i].minDistance);
				}
			}
		}
		
		return distance;
	};
};

Injector.ruleParsers = { };

Injector.ruleParsers.distance = function(ruleData) {
	
	var newRule = {
		ruleType: "distance",
		symbolId: ruleData.symbolId,
		preceeding: ruleData.preceeding,
		minDistance: ruleData.minDistance
	};
	
	newRule.validateSymbol = function(symbolId, preSymbolData, postSymbolData, ruleData, reversed) {
		if (symbolId !== this.symbolId) {
			if (this.preceeding.indexOf(symbolId) === -1) {
				return symbolId;
			}
			
			if (this.checkSymbolData(preSymbolData, postSymbolData, [ this.symbolId ], ruleData.maxGroupLength) === undefined) {
				return undefined;
			}
		}
		else {
			if (this.checkSymbolData(preSymbolData, postSymbolData, this.preceeding, ruleData.maxGroupLength) === undefined) {
				return undefined;
			}
		}
		
		var symbolDistances = ruleData.lastDrawn;
		if (symbolDistances[symbolId] !== undefined) {
			if (symbolDistances[symbolId] < this.minDistance) {
				return undefined;
			}
		}
	
		return symbolId;
	};
	
	newRule.checkSymbolData = function(preSymbolData, postSymbolData, symbols, distanceToPre) {
		var result = this.checkPreSymbolData(preSymbolData, symbols, distanceToPre);
		if (result !== undefined) {
			result = this.checkPostSymbolData(postSymbolData, symbols);
		}
		
		return result;
	};
	
	newRule.checkPreSymbolData = function(preSymbolData, symbols, distanceToPre) {
		var symbolsToCheck = Math.min(this.minDistance, preSymbolData.length);
		for (var i = 1; i <= symbolsToCheck; ++i) {
			var preSymbolIndex = ((preSymbolData.length - i) + distanceToPre);
			if ((preSymbolIndex >= 0) && (preSymbolIndex < preSymbolData.length)) {
				for (var j = 0; j < symbols.length; ++j) {
					if (preSymbolData[preSymbolIndex].symbolId === symbols[j]) {
						return undefined;
					}
				}
			}
		}
		
		return { };
	};
	
	newRule.checkPostSymbolData = function(postSymbolData, symbols) {
		var symbolsToCheck = Math.min(this.minDistance, postSymbolData.length);
		for (var i = 0; i < symbolsToCheck; ++i) {
			for (var j = 0; j < symbols.length; ++j) {
				if (postSymbolData[i].symbolId === symbols[j]) {
					return undefined;
				}
			}
		}
		
		return { };
	};
	
	return newRule;
};

Injector.ruleParsers.group = function(ruleData) {
	
	var newRule = {
		ruleType: "group",
		symbolId: ruleData.symbolId,
		proceeding: ruleData.proceeding,
		proceedingChance: ruleData.proceedingChance,
		proceedingWeights: [],
		proceedingWeightsSum: 0
	};
	
	if (newRule.proceedingChance !== undefined) {
		for (var i = 0; i < newRule.proceedingChance.length; ++i) {
			var chance = newRule.proceedingChance[i].chance;
			newRule.proceedingWeights.push(chance);
			newRule.proceedingWeightsSum += chance;
		}
	}
	
	newRule.validateSymbol = function(symbolId, preSymbolData, postSymbolData, ruleData, reversed) {
		if (symbolId !== this.symbolId) {
			return symbolId;
		}
		
		var proceedingValues = this.proceeding;
		if (this.proceedingChance !== undefined) {
			var index = getRandomWeighted(this.proceedingWeights, this.proceedingWeightsSum);
			proceedingValues = this.proceedingChance[index].proceeding;
		}
		
		if ((proceedingValues.length >= ruleData.maxGroupLength) && (ruleData.maxGroupLength >= 0)) {
			return undefined;
		}
		
		if (reversed) {
			var values = proceedingValues.slice();
			values.reverse();
			values.push(this.symbolId);
			return values;
		}
		
		return proceedingValues.slice();
	};
	
	return newRule;
};

Injector.ruleParsers.replacement = function(ruleData) {
    
    var newRule = {
        ruleType: "replacement",
        symbolId: ruleData.symbolId,
        replaceSymbolId: ruleData.replaceSymbolId
    };
    
    newRule.validateSymbol = function(symbolId, preSymbolData, postSymbolData, ruleData, reversed) {
        if (symbolId === this.symbolId){
            return this.replaceSymbolId;
        }
        
        return symbolId;
    };
    
    return newRule;
}

Injector.ruleParsers.supersized = function(ruleData) {

	var newRule = {
		ruleType: "supersized",
		symbolId: ruleData.symbolId,
		blankSymbolId: ruleData.blankSymbolId
	};

	newRule.validateSymbol = function(symbolId, preSymbolData, postSymbolData, ruleData, reversed) {
		if (symbolId !== this.symbolId) {
			return symbolId;
		}

		return [ this.symbolId, this.blankSymbolId, this.blankSymbolId ];
	};

	return newRule;
}